export default {
  getOrgTypes: state => state.orgTypes,
  getOrgData: state => state.orgData,
  getOnlyUserOrgs: state => state.myOrgList,
  getBrowseOrgs: state => state.otherOrgList,
  getSearchMembers: state => state.serchMembers,
  getNumFollowersChannel: state => state.numFollowersChannel,
  getOrgPosts: state => state.orgPosts,
  getOrgLoadStatus: state => state.isLoading,
  getJoinRequests: state => state.joinRequests,
  getNoSearchMembers: state => state.noSearchMembers,
};
